// Object fit
(function () {
  if (!!((window.CSS && window.CSS.supports) || window.supportsCSS || false) && CSS.supports('object-fit', 'cover')) return;
  $('img.js-object-fit').each(function () {
    var $img = $(this);
    $img.replaceWith('<div class="' + $img.attr('class') + '" style="background-image: url(' + $img.attr('src') + ');"/>');
  });
})();
